<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About The Author</h1>
<p>‘Big Chick’ Huntsberry, who served as Prince’s bodyguard from 1980 to 1985, moved with his family from Tennessee to Chanhassen, MN, in 1984 to work with Prince. Chick started a bodyguard school and a ministry after leaving Prince’s employment.</p>
<p>Charles ‘Big Chick’ Huntsberry passed away from heart failure on 2 April 1990.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?3f8907b7